import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookFreeVisit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="60334" id="avslutande-cta" className="dark bg-background text-foreground py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/pattern_forest.png)] opacity-5 mix-blend-overlay pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 relative z-10 flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight mb-8 max-w-3xl">
          Hittat något du gillar?
        </h2>
        
        <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mb-10 leading-relaxed font-default">Låt dina badrumsidéer bli verklighet! Vi hjälper dig att förverkliga ett badrum som kombinerar personlig stil, smarta lösningar och hållbara materialval. Berätta om dina planer och ta första steget mot en badrumsrenovering i Karlstad, Arvika eller övriga Värmland.</p>

        <Link to="/QuoteRequestPage">
          <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 transition-all duration-300 font-default font-semibold text-lg h-14 px-8 shadow-xl border-none">
            Begär offert
            <ArrowRight className="ml-2 size-5" />
          </Button>
        </Link>
      </div>
    </section>;
}